import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// routes
import { PATH_DASHBOARD, PATH_AUTH } from '../routes/paths';
// components
import LoadingScreen from '../components/loading-screen';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isInitialized } = useAuthContext();
  const [userData, setUserData] = useState<string | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      const userDetailsString = localStorage.getItem('userdetails');
      if (userDetailsString) {
        try {
          const user = JSON.parse(userDetailsString);
          setUserData(user.role);
        } catch (error) {
          console.error('Error parsing user details:', error);
        }
      }
    };
    fetchUser();
  }, []);

  console.log(userData === 'SuperAdmin');

  if (isAuthenticated) {
    if (userData === 'SuperAdmin') {
      return <Navigate to={PATH_DASHBOARD.root} />;
    }
    return <Navigate to={PATH_AUTH.root} />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
